exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fav-container{display:inline-block;margin:0 10px;height:40px;line-height:40px}.fav-table{max-height:350px;overflow:auto}.my-fav.el-popover{padding:8px}.my-fav .el-popover__title{margin-bottom:5px;padding:5px 0;font-weight:800;font-size:15px}.my-fav .el-table td,.my-fav .el-table th{height:30px}.my-fav .el-table__column-filter-trigger i{color:#00f;font-size:14px;font-weight:bolder}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-544fb360","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/favorites/src/main.vue
// module id = 989
// module chunks = 1